module.exports = __webpack_public_path__ + "static/media/Currículum.9ac71144.pdf";